import { Suspense, lazy } from "react";

import { CircularProgressCenter } from "igfd-ui/src/app-index";

const DevComponent = lazy(() => import("./dev-component"));

// Lazy load the dev page
export const DevPage = () => {
  return (
    <Suspense fallback={<CircularProgressCenter />}>
      <DevComponent />
    </Suspense>
  );
};
